import { ButtonProps } from "../../../../types"
import Button from "../button"

const LightBtn = ({ children, className = "", ...rest }: ButtonProps) => (
  <Button
    {...rest}
    className={`${className} border-transparent text-primary-alt-400 bg-zinc-100 hover:bg-zinc-200 focus:ring-zinc-300`}
  >
    {children}
  </Button>
)

export default LightBtn
